<template>
  <el-card>
    <div slot="header">
      Adatok
    </div>
    <el-form
      :key="formKey"
      ref="dataForm"
      label-position="top"
      :model="stockTakingData"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            label="Leltár kiértékelő"
            prop="evaluate_user"
          >
            <el-select
              v-model="stockTakingData.evaluate_user"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Gazdasági vezető"
            prop="financial_lead_user"
          >
            <el-select
              v-model="stockTakingData.financial_lead_user"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Könyvelő"
            prop="accountant_user"
          >
            <el-select
              v-model="stockTakingData.accountant_user"
              style="width: 100%;"
              :disabled="dialogType === 'view'"
              filterable
              value-key="id"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <h4>Leltározási jegyzőkönyv</h4>
      <el-row :gutter="20" style="display: flex; align-items: center;">
        <el-col :span="12">
          <el-form-item
            prop="is_review_required"
            style="margin-bottom: 0"
          >
            <el-checkbox
              v-model="stockTakingData.is_review_required"
              :disabled="dialogType === 'view'"
            >
              Leltár ellenőrzés
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Leltár ellenőrző"
            prop="reviewer_user"
          >
            <el-select
              v-model="stockTakingData.reviewer_user"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <h4>Megbízólevél</h4>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Leltár vezető"
            prop="stock_taking_lead_user"
          >
            <el-select
              v-model="stockTakingData.stock_taking_lead_user"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <h4>Pénzeszközök és értékcikkek</h4>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Pénztáros"
            prop="cashier_user"
          >
            <el-select
              v-model="stockTakingData.cashier_user"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Leltározó"
            prop="stock_taking_user"
          >
            <el-select
              v-model="stockTakingData.stock_taking_user"
              style="width: 100%;"
              filterable
              :disabled="dialogType === 'view'"
              value-key="id"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
  export default {
    props: ['stockTakingReport', 'dialogType'],
    data() {
      return {
        stockTakingData: {
          evaluate_user: null,
          financial_lead_user: null,
          accountant_user: null,
          stock_taking_lead_user: null,
          cashier_user: null,
          stock_taking_user: null,
          reviewer_user: null,
          is_review_required: false,
        },
        formKey: 0,
        rules: {
          evaluate_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          financial_lead_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          accountant_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          stock_taking_lead_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          stock_taking_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          reviewer_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
          cashier_user: [
            {
              required: true,
              message: 'Mező megadása kötelező',
              trigger: 'change'
            }
          ],
        },
      }
    },
    computed: {
      users() {
        return this.$store.getters['user/users'];
      }
    },
    watch: {
      stockTakingReport(newVal) {
        this.stockTakingData.evaluate_user = Object.assign({}, newVal.evaluate_user);
        this.stockTakingData.cashier_user = Object.assign({}, newVal.cashier_user);
        this.stockTakingData.financial_lead_user = Object.assign({}, newVal.financial_lead_user);
        this.stockTakingData.accountant_user = Object.assign({}, newVal.accountant_user);
        this.stockTakingData.stock_taking_lead_user = Object.assign({}, newVal.stock_taking_lead_user);
        this.stockTakingData.stock_taking_user = Object.assign({}, newVal.stock_taking_user);
        this.stockTakingData.reviewer_user = Object.assign({}, newVal.reviewer_user);
        this.stockTakingData.is_review_required = newVal.is_review_required;
        this.formKey++;
      },

    }
  }
</script>
